<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="促销价格"
      id-key="PromotionalPriceId"
      :data="data"
      :get-data-func="() => {}"
      :save-func="() => {}"
      :before-save="beforeSave"
      :line-form="true"
      form-label-width="110px"
      :form-rules="rules"
      @create-opened="onCreate"
      @close-saved="$emit('close-saved')"
      @edit-opened="onEditOpened"
      @opened="onOpened"
      @closed="over"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  v-model="data.DocDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单据编码" prop="DocNo">
                <span v-if="Mode == 0" class="detail-span">{{
                  data.DocNo
                }}</span>
                <el-input
                  v-else
                  v-model="data.DocNo"
                  placeholder="请输入单据编码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销开始日期" prop="PromotionStartDate">
                <el-date-picker
                  v-model="data.PromotionStartDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销开始时间" prop="PromotionStartTime">
                <el-time-select
                  v-model="data.PromotionStartTime"
                  :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '18:30',
                  }"
                  placeholder="选择时间"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销结束日期" prop="PromotionEndDate">
                <el-date-picker
                  v-model="data.PromotionEndDate"
                  type="date"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销结束时间" prop="PromotionEndTime">
                <el-time-select
                  v-model="data.PromotionEndTime"
                  :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '18:30',
                  }"
                  placeholder="选择时间"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="促销星期" prop="PromotionWeek">
                <el-select v-model="data.PromotionWeek" multiple>
                  <el-option value="星期一" label="星期一"></el-option>
                  <el-option value="星期二" label="星期二"></el-option>
                  <el-option value="星期三" label="星期三"></el-option>
                  <el-option value="星期四" label="星期四"></el-option>
                  <el-option value="星期五" label="星期五"></el-option>
                  <el-option value="星期六" label="星期六"></el-option>
                  <el-option value="星期七" label="星期七"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销客户分类" prop="TradeUnitType">
                <el-select v-model="data.TradeUnitType">
                  <el-option
                    v-for="item in tradeUnitList"
                    :key="item.ClassId"
                    :value="item.ClassId"
                    :label="item.ClassName"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="促销对象" prop="PromotionTarget">
                <el-select v-model="data.PromotionTarget">
                  <el-option :value="0" label="商品"></el-option>
                  <el-option :value="1" label="商品分类"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <template v-if="data.PromotionTarget === 0">
          <div class="row-tb-head" style="margin-top: 10px">
            <span>商品列表</span>
            <div style="float: right">
              <el-button type="primary" @click="add">添加</el-button>
            </div>
          </div>
          <el-table
            :data="GoodsModels"
            @selection-change="handleSelectionList"
            border
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="商品编码" prop="ProductNo" align="center" />
            <el-table-column label="商品名称" align="center" min-width="120px">
              <template slot-scope="{ row }">
                <account-select
                  v-model="row.ProductName"
                  :source="DAccount"
                  @select="onSelect($event, row)"
                  :pageSize="pageParams.pageSize"
                  :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="true"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="规格型号"
              prop="ProductSpec"
              align="center"
            />

            <el-table-column label="计量单位" prop="UnitName" align="center">
              <template slot-scope="{ row }">
                <el-select v-if="optionList.length > 0" v-model="row.UnitId">
                  <el-option
                    v-for="item in optionList"
                    :key="item.UnitId"
                    :value="item.UnitId"
                    :label="item.UnitName"
                    @click.native="changT(row)"
                  ></el-option>
                </el-select>
                <span v-else>{{ row.UnitName }}</span>
              </template>
            </el-table-column>

            <el-table-column label="促销价" align="center" min-width="120px" v-if="(canPrice && data.PromotionalPriceId) || !data.PromotionalPriceId">
              <template slot-scope="{ row }">
                <el-input
                  type="number"
                  v-model="row.PromotionalPrice"
                  placeholder="请输入促销价"
                  @change="changT(row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="每单限售数量"
              align="center"
              min-width="100px"
            >
              <template slot-scope="{ row }">
                <el-input
                  type="number"
                  v-int
                  v-model="row.RestrictedQuantity"
                  placeholder="请输入每单限售数量"
                  @change="changT(row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" min-width="160px">
              <template slot-scope="{ row }">
                <el-input
                  type="textarea"
                  v-model="row.Remark"
                  :autosize="{ minRows: 1, maxRows: 2 }"
                  maxlength="50"
                  show-word-limit
                  @change="changT(row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="55">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(row, $index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template v-if="data.PromotionTarget === 1">
          <div class="row-tb-head" style="margin-top: 10px">
            <span>商品分类列表</span>
            <div style="float: right">
              <el-button type="primary" @click="add">添加</el-button>
            </div>
          </div>
          <el-table
            :data="ClassModels"
            @selection-change="handleSelectionCategory"
            border
          >
            <el-table-column type="selection" width="55" />
            <el-table-column
              prop="ClassNo"
              label="商品分类编码"
              align="center"
            />
            <el-table-column label="商品分类名称" align="center">
              <template slot-scope="{ row }">
                <el-select v-model="row.ClassId">
                  <el-option
                    v-for="item in ClassList"
                    :key="item.ClassId"
                    :value="item.ClassId"
                    :label="item.ClassName"
                    @click.native="onClassData(row, item)"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="折扣率%" align="center">
              <template slot-scope="{ row }">
                <el-input
                  type="number"
                  v-model="row.DiscountRate"
                  placeholder="请输入折扣率"
                  @change="changT(row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="每单限售数量" align="center">
              <template slot-scope="{ row }">
                <el-input
                  type="number"
                  v-int
                  v-model="row.RestrictedQuantity"
                  placeholder="请输入每单限售数量"
                  @change="changT(row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="备注" align="center" min-width="160px">
              <template slot-scope="{ row }">
                <el-input
                  type="text"
                  v-model="row.Remark"
                  placeholder="请输入备注"
                  @change="changT(row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="55">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(row, $index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import accountSelect from "@/components/production/clothmanagement/cloth/select";

// import iForm from '@/data/sys/user/IForm.json'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    accountSelect,
  },
  props: {
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/sa/promotionalPrice").default,
      productApi: require("@/api/ba/product").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      classApi: require("@/api/ba/class").default,
      Mode: 0,
      ClassList: [],
      ClassModels: [],
      GoodsModels: [],
      multipleList: null,
      multipleCategory: null,
      data: {
        PromotionalPriceId: 0,
        DocNo: "",
        DocDate: "",
        PromotionStartDate: "",
        PromotionStartTime: "",
        PromotionEndDate: "",
        PromotionEndTime: "",
        PromotionWeek: [],
        TradeUnitType: null,
        PromotionTarget: 0,
        // Status: 0,
        IsDeactivate: true,
        // MakeEmpId: 0,
        // MakeDate: "",
        // ReviewEmpId: 0,
        // ReviewDate: "",
        UpdateEmpId: 0,
        UpdateDate: "",
        AddUserId: 0,
        AddTime: "",
        // MakeEmpName: "",
        // ReviewEmpName: "",
        ClassModels: [],
        GoodsModels: [],
        PromotionWeek: [],
      },
      rules: {
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        DocNo: [{ required: true, message: "单据编码不能为空" }],
        PromotionStartDate: [
          { required: true, message: "促销开始日期不能为空" },
        ],
        PromotionStartTime: [
          { required: true, message: "促销开始时间不能为空" },
        ],
        PromotionEndDate: [{ required: true, message: "促销结束日期不能为空" }],
        PromotionEndTime: [{ required: true, message: "促销结束时间不能为空" }],
        PromotionWeek: [{ required: true, message: "促销星期不能为空" }],
        TradeUnitType: [{ required: true, message: "促销客户分类不能为空" }],
        PromotionTarget: [{ required: true, message: "促销对象不能为空" }],
      },
      tradeUnitList: [],
      initDAccount: [],
      optionList: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/sales/salemanage');
    },
  },
  created() {
    this.data.UpdateEmpId = this.$commonJs.empId();
    this.data.UpdateDate = this.$commonJs.getToday();
    this.data.AddUserId = this.$commonJs.userId();
    this.data.AddTime = this.$commonJs.getToday();
  },
  methods: {
    changT(row) {
      if (row.T == 3) row.T = 1;
    },
    previewNo() {
      this.code_api.previewNo("促销价格").then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取促销价格编码失败");
        }
      });
    },
    onOpened() {
      this.classApi.list({ ClassType: 1 }).then((res) => {
        // console.log("class", res.Data);
        if (res.Code == 0) this.ClassList = res.Data;
      });
      this.classApi.list({ ClassType: 17 }).then((res) => {
        if (res.Code == 0) this.tradeUnitList = res.Data;
      });

      this.productApi.list({ Property: "销售" }).then((res) => {
        this.DAccount = res.Data;
        this.initDAccount = res.Data;
        this.listTotal = res.Count;
        this.initTotal = res.Count;
      });
    },
    onCreate() {
      this.previewNo();
      // console.log("object");
      this.data.DocDate = this.getDate();
    },
    onEditOpened(data) {
      console.log("data", data);
      this.api.info(data.PromotionalPriceId).then((res) => {
        if (res.Code == 1) {
          res.Data.PromotionWeek = res.Data.PromotionWeek.split(",");
          this.GoodsModels = res.Data.GoodsModels.map((i) => ((i.T = 3), i));
          this.ClassModels = res.Data.ClassModels?.map((i) => ((i.T = 3), i));
          this.data = res.Data;
        }
      });
    },
    add() {
      if (this.data.PromotionTarget === 0) {
        this.GoodsModels.push({
          T: 0,
          PromotionalGoodsId: 0,
          // PromotionalPriceId: 0,
          ProductId: 0,
          PromotionalPrice: 0,
          RestrictedQuantity: 0,
          Remark: "",
          UnitId: 0,
          UnitName: "",
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
        });
      }
      if (this.data.PromotionTarget === 1) {
        this.ClassModels.push({
          T: 0,
          PromotionalClassId: 0,
          // PromotionalPriceId: 0,
          ClassId: null,
          DiscountRate: 0,
          RestrictedQuantity: 0,
          Remark: "",
          ClassNo: "",
          ClassName: "",
        });
      }
    },
    del(data, index) {
      if (this.data.PromotionTarget === 0) {
        this.GoodsModels.splice(index, 1);
      }
      if (this.data.PromotionTarget === 1) {
        this.ClassModels.splice(index, 1);
      }
    },
    onClassData(row, data) {
      // console.log('item',item);
      row.ClassNo = data.ClassNo;
      row.ClassName = data.ClassName;
    },
    handleSelectionList(val) {
      this.multipleList = val;
    },
    handleSelectionCategory(val) {
      this.multipleCategory = val;
    },
    beforeSave() {},
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        let Product, TableList;
        // 商品
        if (this.data.GoodsModels.length > 0) {
          Product = JSON.parse(JSON.stringify(this.data.GoodsModels));
          TableList = JSON.parse(JSON.stringify(this.GoodsModels));
          let delIds = this.GoodsModels.map((item) => item.PromotionalGoodsId);
          let delList = this.data.GoodsModels.reduce((arr, item) => {
            if (!delIds.includes(item.PromotionalGoodsId))
              arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.GoodsModels.map(
            (item) => item.PromotionalGoodsId
          );
          let addList = [];
          addList = this.GoodsModels.reduce((arr, item) => {
            if (!addIds.includes(item.PromotionalGoodsId))
              arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.GoodsModels.filter((i) => i.T == 1);
          this.data.GoodsModels = [...addList, ...delList, ...updateList];
        } else this.data.GoodsModels = this.GoodsModels;

        // 商品分类
        if (this.data.ClassModels.length > 0) {
          Product = JSON.parse(JSON.stringify(this.data.ClassModels));
          TableList = JSON.parse(JSON.stringify(this.ClassModels));
          let delIds = this.ClassModels.map((item) => item.PromotionalClassId);
          let delList = this.data.ClassModels.reduce((arr, item) => {
            if (!delIds.includes(item.PromotionalClassId))
              arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.ClassModels.map(
            (item) => item.PromotionalClassId
          );
          let addList = [];
          addList = this.ClassModels.reduce((arr, item) => {
            if (!addIds.includes(item.PromotionalClassId))
              arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.ClassModels.filter((i) => i.T == 1);
          this.data.ClassModels = [...addList, ...delList, ...updateList];
        } else this.data.ClassModels = this.ClassModels;

        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        console.log(data.PromotionWeek);
        data.PromotionWeek = data.PromotionWeek.join();
        this.$refs.dialog.isLoading = true;

        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            console.log('1',this.$parent.reload());
            this.$parent.reload();
            this.close(true);
           
          } else {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.$message.error(res.Msg);
          }
        });
      });
    },
    getDate() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = " 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`; //
      return defaultDate;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.productApi
        .list({ Property: "销售", pageIndex: val, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.productApi
        .list({
          Property: "销售",
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].SaUnitName = data[0].SaUnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      let Product = this.GoodsModels.map((i) => i.ProductId);
      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");
      if (this.data.TradeUnitId === null)
        return this.$message.warning("请先选择客户");
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.UnitId = e.SaUnitId;
      row.UnitName = e.SaUnitName;
      this.optionList = e.Units;

      if (e.UnitType === 0) {
        row.UnitId2 = e.SaUnitId;
        row.UnitName2 = e.SaUnitName;
      }

    },
    over() {
      
      this.ClassModels = [];
      this.GoodsModels = [];
    },
  },
};
</script>

<style lang="scss" scoped></style>
